export const NON_NEGATIVE_INTEGER_MESSAGE =
  "Enter a whole number of 0 or greater.";

export type NonNegativeIntegerValidationResult =
  | { ok: true; normalized: number }
  | { ok: false; message: string };

export function validateNonNegativeInteger(
  raw: unknown,
): NonNegativeIntegerValidationResult {
  let normalized: number;

  if (typeof raw === "number") {
    normalized = raw;
  } else if (typeof raw === "string" && /^\d+$/.test(raw.trim())) {
    normalized = Number(raw.trim());
  } else {
    return { ok: false, message: NON_NEGATIVE_INTEGER_MESSAGE };
  }

  if (!Number.isSafeInteger(normalized) || normalized < 0) {
    return { ok: false, message: NON_NEGATIVE_INTEGER_MESSAGE };
  }

  return { ok: true, normalized };
}
